type EnvironmentKey =
  | "REACT_APP_APP_INSIGHTS_CONNECTION_STRING"
  | "REACT_APP_AUTOSAVE_INTERVAL"
  | "REACT_APP_CHECK_MAINTENANCE_MODE_INTERVAL"
  | "REACT_APP_ENV"
  | "REACT_APP_FETCH_SYSTEM_ADMINISTRATION_MESSAGES_INTERVAL"
  | "REACT_APP_FROALA_LICENSE_KEY"
  | "REACT_APP_MINIMAL_TOTAL_ENGAGEMENT_COST"
  | "REACT_APP_MSAL_CLIENT_ID"
  | "REACT_APP_MSAL_SCOPE"
  | "REACT_APP_MSAL_SHAREPOINT_ACCESS_SCOPE"
  | "REACT_APP_MSAL_TENANT_ID"
  | "REACT_APP_MUI_X_LICENSE_KEY"
  | "REACT_APP_SHOW_CONFIGURATION_CODES"
  | "REACT_APP_SP_DOCUMENTS_FOLDER"
  | "REACT_APP_SP_DOCUMENTS_URL";

type EnvironmentValues = Readonly<Partial<Record<EnvironmentKey, string>>>;

declare global {
  interface Window {
    __ENV__?: EnvironmentValues;
  }
}

// Production bundles are environment-neutral: their values come from env-config.js, written at deploy time.
export const environment: EnvironmentValues =
  process.env.NODE_ENV === "production"
    ? window.__ENV__ ?? {}
    : {
        REACT_APP_APP_INSIGHTS_CONNECTION_STRING:
          process.env.REACT_APP_APP_INSIGHTS_CONNECTION_STRING,
        REACT_APP_AUTOSAVE_INTERVAL: process.env.REACT_APP_AUTOSAVE_INTERVAL,
        REACT_APP_CHECK_MAINTENANCE_MODE_INTERVAL:
          process.env.REACT_APP_CHECK_MAINTENANCE_MODE_INTERVAL,
        REACT_APP_ENV: process.env.REACT_APP_ENV,
        REACT_APP_FETCH_SYSTEM_ADMINISTRATION_MESSAGES_INTERVAL:
          process.env.REACT_APP_FETCH_SYSTEM_ADMINISTRATION_MESSAGES_INTERVAL,
        REACT_APP_FROALA_LICENSE_KEY: process.env.REACT_APP_FROALA_LICENSE_KEY,
        REACT_APP_MINIMAL_TOTAL_ENGAGEMENT_COST:
          process.env.REACT_APP_MINIMAL_TOTAL_ENGAGEMENT_COST,
        REACT_APP_MSAL_CLIENT_ID: process.env.REACT_APP_MSAL_CLIENT_ID,
        REACT_APP_MSAL_SCOPE: process.env.REACT_APP_MSAL_SCOPE,
        REACT_APP_MSAL_SHAREPOINT_ACCESS_SCOPE:
          process.env.REACT_APP_MSAL_SHAREPOINT_ACCESS_SCOPE,
        REACT_APP_MSAL_TENANT_ID: process.env.REACT_APP_MSAL_TENANT_ID,
        REACT_APP_MUI_X_LICENSE_KEY: process.env.REACT_APP_MUI_X_LICENSE_KEY,
        REACT_APP_SHOW_CONFIGURATION_CODES:
          process.env.REACT_APP_SHOW_CONFIGURATION_CODES,
        REACT_APP_SP_DOCUMENTS_FOLDER:
          process.env.REACT_APP_SP_DOCUMENTS_FOLDER,
        REACT_APP_SP_DOCUMENTS_URL: process.env.REACT_APP_SP_DOCUMENTS_URL,
      };
